// eslint-disable-next-line import/prefer-default-export
export const ROBOHASH_PROFILE_PIC = "https://robohash.org";
export const MAX_IMAGE_WIDTH = 694;
export const MAX_IMAGE_HEIGHT = 800;
export const INITIAL_IMAGE_WIDTH = 300;
export const INITIAL_IMAGE_HEIGHT = 250;
export const MIN_IMAGE_WIDTH = 21;
export const MIN_IMAGE_HEIGHT = 21;
export const INITIAL_ESIGN_WIDTH = 200;
export const INITIAL_ESIGN_HEIGHT = 60;
export const MAX_ESIGN_WIDTH = 612;
export const MAX_ESIGN_HEIGHT = 400;
export const MIN_ESIGN_WIDTH = 74;
export const MIN_ESIGN_HEIGHT = 24;

const NORMAL_IMAGE_RENDERING_DETAILS = {
  isImageField: false,
  showImagePlaceholder: true, // for showing the image placeholder
  showImageFieldPlaceholder: false, // for showing the image field placeholder
  showImageFieldHighlight: false, // for showing the image field highlight(green and yellow)
  allowActiveOnClick: false,
  showJustifyButtons: false,
};

const IMAGE_FIELD_RENDERING_DETAILS = {
  isImageField: true,
  showImagePlaceholder: false,
  showImageFieldPlaceholder: true,
  showImageFieldLabel: true,
  showImageFieldHighlight: true,
  allowActiveOnClick: false,
  allowResize: false,
  showJustifyButtons: false,
  allowImageFieldUpdate: false,
  getDefaultValue: false,
  getFieldValue: false,
};

export const IMAGE_RENDERING_DETAILS = {
  DOCUMENT: {
    EDITOR_MODE: {
      NORMAL_IMAGE: {
        ...NORMAL_IMAGE_RENDERING_DETAILS,
        allowActiveOnClick: true,
        showJustifyButtons: true,
      },
      IMAGE_FIELD: {
        ...NORMAL_IMAGE_RENDERING_DETAILS,
        allowResize: true,
        isImageField: true,
        allowActiveOnClick: true,
        allowImageFieldUpdate: false,
        getDefaultValue: true,
        showJustifyButtons: true,
      },
    },
    FORM_MODE: {
      NORMAL_IMAGE: {
        ...NORMAL_IMAGE_RENDERING_DETAILS,
      },
      IMAGE_FIELD: {
        ...IMAGE_FIELD_RENDERING_DETAILS,
        allowResize: true,
        allowActiveOnClick: true,
        getFieldValue: true,
        allowImageFieldUpdate: true,
      },
    },
    FORM_PERMA_LINK_MODE: {
      NORMAL_IMAGE: {
        ...NORMAL_IMAGE_RENDERING_DETAILS,
      },
      IMAGE_FIELD: {
        ...IMAGE_FIELD_RENDERING_DETAILS,
        showImageFieldLabel: false,
        showImageFieldHighlight: false,
        showImageFieldPlaceholder: false,
        getFieldValue: true,
      },
    },
    EDITOR_PERMA_LINK_MODE: {
      NORMAL_IMAGE: {
        ...NORMAL_IMAGE_RENDERING_DETAILS,
      },
      IMAGE_FIELD: {
        ...IMAGE_FIELD_RENDERING_DETAILS,
        showImageFieldLabel: false,
        showImageFieldHighlight: false,
        showImageFieldPlaceholder: false,
        getDefaultValue: true,
      },
    },
  },
  TEMPLATE: {
    EDITOR_MODE: {
      NORMAL_IMAGE: {
        ...NORMAL_IMAGE_RENDERING_DETAILS,
        allowActiveOnClick: true,
        showJustifyButtons: true,
      },
      IMAGE_FIELD: {
        ...IMAGE_FIELD_RENDERING_DETAILS,
        allowActiveOnClick: true,
        getDefaultValue: true,
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/constants/images.js